module.exports = __webpack_public_path__ + "static/media/play_button.53e29fdf.svg";